import { SortingState } from "@tanstack/react-table";
import { atom, useAtomValue, useSetAtom } from "jotai";

const searchState = atom("");

const sortingState = atom<SortingState>([]);

export const useSetFilters = () => {
  const setSearch = useSetAtom(searchState);
  const setSorting = useSetAtom(sortingState);

  return { setSearch, setSorting };
};

export const useFilters = () => {
  const search = useAtomValue(searchState);
  const sorting = useAtomValue(sortingState);

  return { search, sorting };
};
